var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"success"}},[_c('div',{staticClass:"check"}),_c('span',{staticClass:"text bold-strong size-18"},[_vm._v("Se ha guardado con exito")])])
}]

export { render, staticRenderFns }